import React from "react";

const useTimeConverter = () => {
  const timeStringToFloat = ({ timeValue }) => {
    
    if (!timeValue || typeof timeValue !== "string") return NaN;

    const hoursMinutes = timeValue.split(/[.:]/);
    const hours = parseInt(hoursMinutes[0], 10);
    const minutes =
      hoursMinutes.length > 1 ? parseInt(hoursMinutes[1], 10) || 0 : 0;

    if (isNaN(hours) || isNaN(minutes)) return NaN;

    return hours + minutes / 100;
  };

  const timeStringToArithFloat = ({ timeValue }) => {
    if (!timeValue || typeof timeValue !== "string") return NaN;

    const hoursMinutes = timeValue.split(/[.:]/);
    const hours = parseInt(hoursMinutes[0], 10);
    const minutes =
      hoursMinutes.length > 1 ? parseInt(hoursMinutes[1], 10) || 0 : 0;

    if (isNaN(hours) || isNaN(minutes)) return NaN;

    return hours + minutes / 60;
  };

  const floatToTimeString = ({ float }) => {
    if (typeof float !== "number" || isNaN(float) || float < 0) return null;

    let hours = Math.floor(float);

    let minutes = Math.round((float - hours) * 100);

    if (minutes === 60) {
      hours += 1;
      minutes = 0;
    }

    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  return { timeStringToFloat, floatToTimeString, timeStringToArithFloat };
};

export default useTimeConverter;
